(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
(function () {
    var root = document.querySelector('[data-u-root="zmiany"]');
    if (!root || !window.PEWNIAKI_UI_ZMIANY) return;
    root.dataset.gra = __pewniaki_inline_cfg[0];
    var el = document.querySelector('script[type="application/json"][data-page-report]');
    var dane = null;
    try { dane = el ? JSON.parse(el.textContent) : null; } catch (e) { dane = null; }
    var api = window.PEWNIAKI_UI_ZMIANY;
    window.PEWNIAKI_ANALIZA = {
        plik: '/assets/json/db/' + root.dataset.gra + '/analizy/zmiany.json',
        wersja: dane && dane.policzono ? dane.policzono : '',
        render: function (raport) { api.render(root, raport); },
        wnioski: function (raport) { return api.wnioski(raport); },
        onError: function () { api.render(root, null); }
    };
    api.render(root, dane && dane.okna ? dane.okna[__pewniaki_inline_cfg[1]] : dane);
})();
})();
